import {capitalize} from '../../util/util'
import {Link} from 'react-router-dom'

const EventLink = ({eventType,display,client})=>{
	const selector = {
		workout:'Workouts',
		task:'Tasks',
		nutrition:'Nutrition'
	}[eventType]
	return (
		<Link 
			to={`/eventsView/?selector=${selector}&display=${display}&client=${client}&filter=client&view=list`}
			target="_blank"
			style={{fontSize:'14px'}}
		>
			View {capitalize(eventType)}
		</Link>
	)
}

export default EventLink